import React from 'react';
import QuattroIcon from '../../../assets/icons/target/streams/quattroIcon.svg';

export const QuattroTable = () => {
  const levelsList = [
    {
      price: 20,
      oneCycle: 60,
      monthlyCycle: 1800,
    },
    {
      price: 32,
      oneCycle: 96,
      monthlyCycle: 2880,
    },
    {
      price: 43,
      oneCycle: 129,
      monthlyCycle: 3870,
    },
    {
      price: 55,
      oneCycle: 165,
      monthlyCycle: 4950,
    },
    {
      price: 75,
      oneCycle: 225,
      monthlyCycle: 6750,
    },
    {
      price: 105,
      oneCycle: 315,
      monthlyCycle: 9450,
    },
    {
      price: 160,
      oneCycle: 480,
      monthlyCycle: 14400,
    },
    {
      price: 210,
      oneCycle: 630,
      monthlyCycle: 18900,
    },
    {
      price: 320,
      oneCycle: 960,
      monthlyCycle: 28800,
    },
    {
      price: 430,
      oneCycle: 1290,
      monthlyCycle: 38700,
    },
    {
      price: 540,
      oneCycle: 1620,
      monthlyCycle: 48600,
    },
    {
      price: 750,
      oneCycle: 2250,
      monthlyCycle: 67500,
    },
    {
      price: 1070,
      oneCycle: 3210,
      monthlyCycle: 96300,
    },
    {
      price: 1600,
      oneCycle: 4800,
      monthlyCycle: 144000,
    },
    {
      price: 2100,
      oneCycle: 6300,
      monthlyCycle: 189000,
    },
  ];
  return (
    <div className="flex flex-col w-full bg-[rgba(12,12,14,0.10)] border-[0.2rem] border-solid border-[#F1A13B] rounded-[3rem] shadow-[0px_0px_31.091px_0px_rgba(241,161,59,0.10)_inset] space-y-[2.8rem] justify-start w-full mt-[22rem] lg:max-w-full max-w-[120rem] overflow-hidden z-[1] lg:mt-[5rem] lg:rounded-[2.6rem]">
      <div className="flex w-full items-center justify-between pt-[3.4rem] px-[3.4rem] lg:px-[2rem]">
        <span className="text-[2.4rem] font-600 text-white lg:text-[2rem] lg:max-w-[25rem]">
          Quattro <span className="text-white-500">Level Costs and Potential Earnings</span>
        </span>
        <img className="lg:w-[2.4rem] lg:h-[2.4rem]" src={QuattroIcon} />
      </div>
      <div className="flex flex-col w-full">
        <div className="flex justify-between items-end text-white-300 text-[1.4rem] font-500 h-[3.2rem] mb-[2.8rem] lg:text-[1rem] lg:h-full lg:leading-[1.6rem] lg:px-[2rem]">
          <div className="flex-1 text-center font-semibold lg:text-left">Level</div>
          <div className="flex-1 text-center font-semibold lg:max-w-[8rem] lg:text-left ">Level Price, POL</div>
          <div className="flex-1 text-center font-semibold lg:max-w-[8rem]">
            One cycle Reward
            <br /> (+200%), POL
          </div>
          <div className="flex-1 text-center font-semibold lg:text-right lg:w-[10rem]">
            Monthly cycle Reward
            <br className="lg:hidden" /> (+6000%), POL
          </div>
        </div>
        <div className="flex flex-col space-y-[0.2rem]">
          {levelsList.map((item, itemIndex) => {
            return (
              <div
                className={`${
                  (itemIndex < 5 && ' bg-[rgba(241,161,59,0.10)]') ||
                  (itemIndex > 4 && itemIndex < 10 && 'bg-[rgba(241,161,59,0.30)]') ||
                  (itemIndex > 9 && 'bg-[rgba(241,161,59,0.70)]')
                } flex justify-between py-[1.2rem] text-[1.6rem] font-500 text-white leading-none lg:text-[1.4rem] lg:px-[2rem]`}
                key={itemIndex}
              >
                <div className="flex-1 text-center lg:text-left">{itemIndex + 1}</div>
                <div className="flex-1 text-center lg:text-left">{item?.price}</div>
                <div className="flex-1 text-center">{item?.oneCycle}</div>
                <div className="flex-1 text-center lg:text-right">{item?.monthlyCycle}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
